import React, { useEffect, useState, useMemo } from "react";
import { Box, Grow } from "@mui/material";
import BotAjuda from "../../assets/images/afinando-ajuda.svg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


const Bot = () => {
  const [showBot, setShowBot] = useState(false);
  const { session } = useSelector((state) => state.session);
  const navigate = useNavigate();
  
  const ANIMATION_DELAY = 800;
  const ANIMATION_DURATION = 2000;

  const imageHelpStyles = useMemo(() => ({
    position: "fixed",
    cursor: "pointer",
    zIndex: 100,
    display: "flex",
    width: { 
      xs: "6.25rem", 
      sm: "6.875rem", 
      md: "7.5rem", 
      lg: "6.875rem" 
    },
    bottom: {
      xs: "3.75rem",
      sm: "3.75rem",
      md: "3.75rem",
      lg: "1.875rem",
      xl: "0.5rem"
    },
    left: { 
      xs: "1rem", 
      sm: "1.25rem", 
      md: "1.5rem",
      lg: "auto"
    },
    right: { 
      xs: "auto",
      sm: "auto", 
      md: "auto",
      lg: "1.5rem" 
    },
    "@media (max-height: 650px)": {
      bottom: "5.625rem"
    },
    "@media screen and (min-width: 1200px) and (min-height: 650px)": {
      bottom: "0.5rem"
    }
  }), []);

  //Função para renderizar o bot de ajuda
  const handleHelpClick = () => {
    //Se for Paciente renderiza para o zoho desk
    if (session?.my_user?.typeUser?.includes("patient")) {
      console.log("Paciente");
      window.open(
        "https://afinandoocerebro.zohodesk.com/portal/pt-br/kb/afinando-o-cerebro/general",
        "_blank",
        "noopener,noreferrer"
      );
    } else {
      // //Se for profissional renderiza para pixie
      // navigate(routes.R_BOT_AFINANDO);
      // console.log("Profissional");
    }
    //https://audiofoco.com.br/
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowBot(true);
    }, ANIMATION_DELAY);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Grow
      in={showBot}
      timeout={ANIMATION_DURATION}
      style={{
        transformOrigin: "bottom right",
      }}
    >
      <Box
        component="img"
        src={BotAjuda}
        onClick={handleHelpClick}
        sx={imageHelpStyles}
        alt="logo"
      />
    </Grow>
  );
};

export default Bot;
